import React from 'react'
import {
  CFView,
  CFText,
  CFImage,
  CFLink,
  DefaultScreen,
  MobileScreen,
} from 'components'
import Header from './Header'
import OrderPickupButton from './OrderPickupButton'
import OrderDeliveryButton from './OrderDeliveryButton'
import { hero, heroText, mobileHero, mobileHeroText } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView
          h="100vh"
          w="100%"
          image={`url(${mobileHero}) bottom / cover no-repeat`}
          column
          alignCenter
        >
          <Header />
          <CFView textCenter w="100%">
            <CFView>
              <CFImage
                w="95%"
                src={mobileHeroText}
                alt="Golden Spring hero text"
                zIndex={98}
              />
            </CFView>
            <CFView mt="15px" pulsate>
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          h="100vh"
          maxHeight="700px"
          w="100%"
          image={`url(${hero}) 30% / cover no-repeat`}
          zIndex={90}
          column
          justifyBetween
          alignStart
        >
          <Header />
          <CFView column justifyCenter alignStart ml="6vw" h="600px">
            <CFView column justifyCenter alignStart>
              <CFImage
                w="50vw"
                maxWidth="620px"
                src={heroText}
                alt="Golden Spring hero text"
                zIndex={98}
              />
            </CFView>
            <CFView mv="30px" pulsate>
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
